import Amplify from 'aws-amplify';
import aws_exports from 'aws-exports';
Amplify.configure(aws_exports);



// WEBPACK FOOTER //
// ./src/configure/amplify.js